import styled from 'styled-components';

import { media } from 'utils/detection';
import Background from 'components/Background';

export default styled(Background)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  width: 100%;
  height: 100vh;

  ${media.medium`
    position: fixed;
  `}
`;
